import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const OptimistMulticall = ({ callsHuman }) => {
    if (!callsHuman?.length) {
        return null;
    }
    return (_jsx("ul", { className: "text-gray-200 p-4 border border-slate-500 border-collapse", children: callsHuman.map((call, i) => (_jsx("li", { children: _jsxs("pre", { className: "whitespace-pre-wrap break-words", children: ["\u27A4 ", call] }) }, i))) }));
};
export default OptimistMulticall;
